import { CCol, CContainer, CImage, CRow, CSpinner } from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { setDashboardInProgressState } from '../../../../redux/encounters/encountersSlice'
import { format } from 'date-fns'
import { postFusion } from '../../../../apiHelper/fusionApi'
import { hasAdminRole } from '../../../../components/common/shared/sharedRoleLogic'
import moment from 'moment'

export default function ExpiringSoonQuickView() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const [expSoonVisits, setExpSoonVisits] = useState([])
  const [expSoonVisitCount, setExpSoonVisitCount] = useState(0)
  const roles = useSelector((state) => state?.user?.roles) || []

  useEffect(() => {
    const fetchEncounters = async () => {
      try {
        setLoading(true)

        const lowerDateBound = moment().subtract(1, 'year').subtract(1, 'day').format('YYYY-MM-DD')
        const upperDateBound = moment().subtract(1, 'year').add(8, 'days').format('YYYY-MM-DD')

        const response = await postFusion('v1/encounter/list', {
          filter: {
            expiring_soon: true,
            service_date_from_lbound: lowerDateBound,
            service_date_from_ubound: upperDateBound,
          },
          sort: {
            service_date_from: 1,
          },
          limit: 3,
          page: 1,
          scope: 'practice',
        })

        if (response?.encounters) {
          setExpSoonVisits(response?.encounters || [])
          setExpSoonVisitCount(response?.pagination?.record_count || 0)
        }
        setLoading(false)
      } catch (error) {
        console.error('Error fetching dashboard expiring soon encounters:', error)
      }
    }

    fetchEncounters()
  }, [])

  return (
    <div
      className="providerholds-container"
      style={{
        marginBottom: '24px',
      }}
    >
      <div className="header-container">
        <span className="providerholds-heading">Expiring Soon</span>
        <div className="notification-icon-container ExpiringSoon">
          <div className="notification-number">{expSoonVisitCount}</div>
        </div>
      </div>
      <div className="subheading-container pt-2">
        <span className="providerholds-subheading"></span>
        {expSoonVisits?.length > 0 && (
          <span
            className="provider-seeall-link"
            onClick={() => {
              dispatch(
                setDashboardInProgressState({
                  admin: hasAdminRole(roles),
                  substatus: 'expiring_soon',
                }),
              )
              navigate('/encounters')
            }}
          >
            See Expiring Soon Encounters
          </span>
        )}
      </div>
      {expSoonVisits?.length > 0 ? (
        expSoonVisits.map((item, index) => (
          <div key={index}>
            <ExpSoonTile item={item} />
          </div>
        ))
      ) : (
        <div className="noresult-found">
          {loading ? <CSpinner /> : <p>No encounters expiring soon</p>}
        </div>
      )}
    </div>
  )
}

const ExpSoonTile = ({ item }) => {
  return (
    <div className="issuescard-container mt-2">
      <CContainer>
        <CRow>
          <CCol sm="2" className="px-0">
            <div className="issuescard-icon-container m-0">
              <div className="icon-wrapper ExpiringSoon">
                <CImage className="notification-icon" src={''} />
              </div>
            </div>
          </CCol>

          <CCol sm="10">
            <div className="issuescard-data-container">
              <span className="issuescard-heading">
                {item?.patient_lastname}, {item?.patient_firstname}{' '}
                {item?.patient_dob &&
                  format(new Date(item?.patient_dob?.replaceAll('-', '/')), 'MM/dd/yyyy')}
              </span>
              <span className="issuescard-subheading">{item?.facility_name}</span>
              <span className="issuescard-subheading">
                {item?.service_date_from &&
                  format(new Date(item?.service_date_from?.replaceAll('-', '/')), 'MM/dd/yyyy')}
              </span>
            </div>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}
